import {BasePage} from '../utils/base';
import '../css/new.scss';

export class NewUserPage extends BasePage {
  view: HTMLElement;
  nameInput: HTMLInputElement;
  lastNameInput: HTMLInputElement;
  button: HTMLElement;

  disabled: boolean = false;

  constructor() {
    super();

    let viewTemplate = this.templates.querySelector('.new') as HTMLElement;
    this.setPage(viewTemplate.cloneNode(true) as HTMLElement);

    this.view = this.app.querySelector('.new') as HTMLElement;

    this.nameInput = this.view.querySelector('.name') as HTMLInputElement;

    this.nameInput.addEventListener('keydown', this.nameKeyDown);
    this.nameInput.addEventListener('keyup', this.nameChange);

    this.lastNameInput = this.view.querySelector('.last-name') as HTMLInputElement;

    this.lastNameInput.addEventListener('keydown', this.nameKeyDown);
    this.lastNameInput.addEventListener('keyup', this.nameChange);

    this.button = this.view.querySelector('button') as HTMLElement;
    this.addLoading('.button-loading', this.button);

    let disabled = false;

    this.button.addEventListener('click', () => {
      if (disabled) {
        return;
      }

      disabled = true;
      this.nameInput.classList.add('disabled');
      this.lastNameInput.classList.add('disabled');

      this.button.classList.add('loading');
      this.apiHelper.registerUser(this.nameInput.value, this.lastNameInput.value).catch(() => {
        disabled = false;
        this.nameInput.classList.remove('disabled');
        this.lastNameInput.classList.remove('disabled');

        this.button.classList.remove('loading');
      });
    });

    let imgInput = this.view.querySelector('img');

    imgInput.addEventListener('load', () => {
      imgInput.style.height = 'auto';
      imgInput.style.width = 'auto';

      if (imgInput.width > imgInput.height) {
        imgInput.style.height = '100%';
      } else {
        imgInput.style.width = '100%';
      }
      imgInput.style.opacity = 1;
    });

    let fileInput = this.view.querySelector('input[type="file"]') as HTMLInputElement;

    fileInput.addEventListener('change', event => {
      if (!event.target.files || !event.target.files.length) {
        return;
      }
      imgInput.style.opacity = 0;

      const reader = new FileReader();

      reader.onload = e => {
        imgInput.src = e.target.result;
        imgInput.classList.add('loaded');
      };

      reader.readAsDataURL(event.target.files[0]);
    });

    requestAnimationFrame(() => {
      this.nameInput.focus();
    });
  }

  nameKeyDown = (event: KeyboardEvent) => {
    if (this.disabled) {
      event.preventDefault();
    }
  };

  nameChange = (event: KeyboardEvent) => {
    if (this.disabled) {
      return;
    }

    let input = event.srcElement! as HTMLInputElement;
    let name = input.value;

    if (name) {
      input.classList.add('value');
    } else {
      input.classList.remove('value');
    }
  };
}
